/**
 * Marketplace email toggles shared by the API (gating) and the web (profile
 * settings). Every event is on until the user turns it off.
 */
export const MARKETPLACE_EMAIL_EVENTS = [
  { key: "seller_offer_received", side: "seller", label: "Offer received", description: "A buyer makes an offer on your listing." },
  { key: "seller_offer_expired", side: "seller", label: "Offer expired", description: "An offer on your listing runs out with no answer." },
  { key: "seller_listing_sold", side: "seller", label: "Listing sold", description: "Your listing sells at its price or by offer." },
  { key: "seller_auction_ended", side: "seller", label: "Auction ended", description: "Your auction ends, sold or unsold." },
  { key: "seller_proceeds_released", side: "seller", label: "Proceeds released", description: "Held sale proceeds become withdrawable." },
  { key: "buyer_offer_accepted", side: "buyer", label: "Offer accepted", description: "The seller accepts your offer." },
  { key: "buyer_offer_declined", side: "buyer", label: "Offer declined", description: "The seller declines your offer, or the listing closes first." },
  { key: "buyer_offer_countered", side: "buyer", label: "Counter offer", description: "The seller answers your offer with a counter." },
  { key: "buyer_offer_expired", side: "buyer", label: "Offer expired", description: "Your offer or a counter runs out with no answer." },
  { key: "buyer_outbid", side: "buyer", label: "Outbid", description: "Someone outbids you. One email until you bid again." },
  { key: "buyer_auction_won", side: "buyer", label: "Auction won", description: "You win an auction." },
  { key: "buyer_purchase_confirmed", side: "buyer", label: "Purchase confirmed", description: "Your buy-now purchase settles." },
] as const;

export type MarketplaceEmailEventKey = (typeof MARKETPLACE_EMAIL_EVENTS)[number]["key"];

export const MARKETPLACE_EMAIL_EVENT_KEYS = MARKETPLACE_EMAIL_EVENTS.map((event) => event.key) as [
  MarketplaceEmailEventKey,
  ...MarketplaceEmailEventKey[],
];

export interface MarketplaceEmailSettings {
  email: string;
  emailVerified: boolean;
  preferences: Record<MarketplaceEmailEventKey, boolean>;
}

/** House listing emails, sent only to staff chosen in the admin Marketplace area. */
export type MarketplaceAdminEmailEvent = "house_offer" | "house_sale" | "house_auction_ended" | "auto_list_run";
